"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
var initialState = {
    nomber: 0
};
function challengeReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case types_1.SET_CHALLENGE_VALUE:
            return {
                nomber: action.payload.nomber
            };
        case types_1.RESET_CHALLENGE_VALUE:
            return initialState;
        default:
            return state;
    }
}
exports.challengeReducer = challengeReducer;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/store/challenges/reducers.ts
// module id = 2019
// module chunks = 4